/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserGroupAssignment } from './UserGroupAssignment';
import {
    UserGroupAssignmentFromJSON,
    UserGroupAssignmentFromJSONTyped,
    UserGroupAssignmentToJSON,
} from './UserGroupAssignment';

/**
 * 
 * @export
 * @interface CreateUserGroupAssignment201Response
 */
export interface CreateUserGroupAssignment201Response {
    /**
     * 
     * @type {UserGroupAssignment}
     * @memberof CreateUserGroupAssignment201Response
     */
    data?: UserGroupAssignment;
}

/**
 * Check if a given object implements the CreateUserGroupAssignment201Response interface.
 */
export function instanceOfCreateUserGroupAssignment201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateUserGroupAssignment201ResponseFromJSON(json: any): CreateUserGroupAssignment201Response {
    return CreateUserGroupAssignment201ResponseFromJSONTyped(json, false);
}

export function CreateUserGroupAssignment201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUserGroupAssignment201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : UserGroupAssignmentFromJSON(json['data']),
    };
}

export function CreateUserGroupAssignment201ResponseToJSON(value?: CreateUserGroupAssignment201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': UserGroupAssignmentToJSON(value.data),
    };
}

